import React from 'react';
import Divider from 'theme/Divider';
import isEqual from 'react-fast-compare'
import { themedDividerStyle } from 'styles/components/atoms/ThemedDivider'

const ThemedDivider = ( { style = {} } ) => {
	
	const viewStyle = [
		themedDividerStyle.divider,
		style
	]
	
	return (
		<Divider
			style={ viewStyle }
		/>
	)
}

export default React.memo( ThemedDivider, isEqual );
